export default "__VITE_ASSET__Sm2v9jqX__"